import { FC, ReactNode } from 'react'
import { EventAvatar, EventAvatarType } from './Avatar'
import { CalendarCellType, Cell } from './CalendarCell'
import {
  CardWithMemberParticipation,
  CardWithMemberParticipationType,
} from './CardWithMemberParticipation'
import { EventOption, EventOptionType } from './Option'
import { EventStats, EventStatsType } from './Stats'

const Event: FC &
  EventAvatarType &
  EventStatsType &
  EventOptionType &
  CalendarCellType &
  CardWithMemberParticipationType = (): ReactNode => <></>

Event.Avatar = EventAvatar
Event.Stats = EventStats
Event.Option = EventOption
Event.CardWithMemberParticipation = CardWithMemberParticipation
Event.CalendarCell = Cell
export default Event
